// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1mqBI","info":"PatientInfo_info__1xKnZ"};